import { render, staticRenderFns } from "./contact-tags.vue?vue&type=template&id=797fac68&scoped=true&"
import script from "./contact-tags.ts?vue&type=script&lang=ts&"
export * from "./contact-tags.ts?vue&type=script&lang=ts&"
import style0 from "./contact-tags.scss?vue&type=style&index=0&id=797fac68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fac68",
  null
  
)

export default component.exports